import { verify } from '../../ducks/emailVerification.duck';

export const parseVerificationTokenFromSearch = search => {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  return params.get('t') || params.get('verificationToken') || params.get('token') || null;
};

// ================ Load data ================ //

export const loadData = (params, search) => {
  const verificationToken = parseVerificationTokenFromSearch(search);
  return verificationToken ? verify(verificationToken) : null;
};
